export const CONSENT_KEY = "ofix_cookie_consent_v1";
export const CONSENT_EVENT = "ofix:cookie-consent-updated";
export type CookieConsentState = { necessary: true; analytics: boolean; marketing: boolean; ts: number };
export function parseConsent(raw: string | null): CookieConsentState {
  try {
    const c = JSON.parse(raw || "null");
    return { necessary: true, analytics: c?.analytics === true, marketing: c?.marketing === true, ts: typeof c?.ts === "number" ? c.ts : 0 };
  } catch { return { necessary: true, analytics: false, marketing: false, ts: 0 }; }
}
export function readConsent(): CookieConsentState {
  try { return parseConsent(window.localStorage.getItem(CONSENT_KEY)); }
  catch { return parseConsent(null); }
}
export function hasConsent(category: "analytics" | "marketing") { return readConsent()[category]; }
export function subscribeConsent(callback: () => void) {
  const storage = (event: StorageEvent) => { if (event.key === CONSENT_KEY || event.key === null) callback(); };
  window.addEventListener(CONSENT_EVENT, callback);
  window.addEventListener("storage", storage);
  return () => { window.removeEventListener(CONSENT_EVENT, callback); window.removeEventListener("storage", storage); };
}